import { html } from 'lit';
const Style =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.25 5.45c0-1.204.964-2.2 2.178-2.2h11.144c1.214 0 2.178.996 2.178 2.2v5.394c0 1.478-.84 2.83-2.166 3.468l-1.842.884a1.274 1.274 0 0 0-.683 1.41l.054.26c.414 1.987-1.077 3.884-3.113 3.884s-3.527-1.897-3.113-3.884l.054-.26a1.27 1.27 0 0 0-.683-1.41l-1.842-.884a3.84 3.84 0 0 1-2.166-3.468zm1.503 5.522a2.34 2.34 0 0 0 1.313 1.988l1.841.883a2.77 2.77 0 0 1 1.503 3.068l-.055.26c-.226 1.085.59 2.079 1.645 2.079s1.87-.994 1.645-2.079l-.055-.26a2.77 2.77 0 0 1 1.503-3.068l1.842-.883a2.34 2.34 0 0 0 1.312-1.988zm12.497-1.5H5.75V5.45c0-.398.314-.7.678-.7h2.197v2.806a.75.75 0 0 0 1.5 0V4.75h3.75v1.917a.75.75 0 0 0 1.5 0V4.75h2.197a.69.69 0 0 1 .678.7z" clip-rule="evenodd"/>
  </svg>
`;
export default Style;
